import Vue from 'vue'
import Router from 'vue-router'
import Config from '@/config'

Vue.use(Router)

console.debug('Initializing router')

export default function createRouter (component, props = {}) {
  return new Router({
    mode: props.routerMode || Config.routerMode,
    routes: [
      {
        path: '/(assessments/)?:id(\\d+)',
        name: 'Assessment',
        component,
        props: true
      }
    ]
  })
}

console.debug('Initialized router')
